import { APIResponse } from '../../../@types/api-response';
import { TargetType } from './shareTradeTarget';

export enum ShareOrderType {
  Unspecified = 'ORDER_TYPE_UNSPECIFIED',
  Buy = 'ORDER_TYPE_BUY',
  Sell = 'ORDER_TYPE_SELL',
}

export enum ShareOrderStatus {
  Unspecified = 'ORDER_STATUS_UNSPECIFIED',
  Open = 'ORDER_STATUS_OPEN',
  Amend = 'ORDER_STATUS_AMEND',
  Cancel = 'ORDER_STATUS_CANCEL',
  Match = 'ORDER_STATUS_MATCH',
  PartialMatch = 'ORDER_STATUS_PARTIAL_MATCH',
}

export type PostShareResponse = APIResponse;

export interface TargetShareItem {
  id: number;
  type: TargetType;
}

export interface PostShareRequestBody {
  order_id: string;
  targets: TargetShareItem[];
  symbol: string;
  price: number;
  type: ShareOrderType;
  status: ShareOrderStatus;
  save_as_autoshare: boolean;
  order_time: string;
}
